module.exports = __webpack_public_path__ + "img/hdd.23c06ca3.png";